// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import { classList } from '@Helpers/className';
import { useLocalMessage } from '@Helpers/locale';
import { Menu, Dropdown } from 'antd';
import React, { ReactElement } from 'react';
import { PinType, usePin } from '../context';

import './ShortcutPin.scss';

interface ShortcutPinProps {
    caseId: string;
    type: string;
    className?: string;
    onClick: (pin: PinType) => void;
}
const defaulData = { caseId: '-', type: '-' };

export const ShortcutPin = ({ caseId, type = '', className, onClick }: ShortcutPinProps): ReactElement | null => {
    const { getPinsCase, setShortcutVisible, togglePin, getLimit, removeMultiPin } = usePin();
    const local = useLocalMessage();

    const pins = getPinsCase(caseId) || {};
    const list = pins?.[type] || [];
    const data = { ...defaulData, ...{ caseId, type } } as PinType;
    const limit = getLimit?.(data);

    const msg = limit ? 'info' : 'limit';

    const menu = (
        <Menu className="short-cut-pin__menu">
            {list.map((pin) => (
                <Menu.Item key={pin.id} className="short-cut-pin__item">
                    <span
                        className="short-cut-pin__title"
                        onClick={(): void => {
                            setShortcutVisible(false);
                            onClick(pin);
                        }}
                    >
                        {pin.title}
                    </span>
                    <span
                        className="short-cut-pin__btn"
                        onClick={(): void => {
                            setShortcutVisible(false);
                            togglePin(pin);
                        }}
                    >
                        <ICONS.DeleteIcon />
                    </span>
                </Menu.Item>
            ))}
            <Menu.Item key="info" className={classList('short-cut-pin__info', { limited: limit <= 0 })}>
                {local(`pin.shortcut.${msg}`, { limit })}
            </Menu.Item>
            <Menu.Item
                key="remove"
                className={classList('short-cut-pin__info-remove')}
                onClick={(): void => {
                    removeMultiPin(list);
                    setShortcutVisible(false);
                }}
            >
                {local('pin.shortcut.remove-all')}
            </Menu.Item>
        </Menu>
    );

    return list.length ? (
        <Dropdown placement="bottomRight" overlay={menu} onVisibleChange={(e): void => setShortcutVisible(e)}>
            <span className={classList('short-cut-pin', className)}>
                <ICONS.DownOutlined />
            </span>
        </Dropdown>
    ) : null;
};
